import type { Department } from "../contexts/AuthProvider";

/** The department switcher's order — hospital, then name, then id — shared so anything ranked by department agrees with it. */
export const compareDepartments = (a: Department, b: Department): number =>
	a.hospital.localeCompare(b.hospital) || a.display_name.localeCompare(b.display_name) || a.department_id.localeCompare(b.department_id);
